import { DualBannerProps, AdaptedDualBannerProps, BannerImageItem } from './DualBanner.types';

/**
 * 배열에서 랜덤하게 2개의 아이템을 선택하는 함수
 */
function selectRandomImages(images: BannerImageItem[]): [BannerImageItem, BannerImageItem] {
  if (!images || images.length === 0) {
    // 기본 이미지 반환
    const defaultImage: BannerImageItem = {
      imageUrl: 'https://via.placeholder.com/600x400',
      altText: '기본 이미지'
    };
    return [defaultImage, defaultImage];
  }

  if (images.length === 1) {
    // 이미지가 1개만 있으면 같은 이미지 2개 반환
    return [images[0], images[0]];
  }

  if (images.length === 2) {
    // 이미지가 2개면 그대로 반환
    return [images[0], images[1]];
  }

  // 이미지가 3개 이상이면 랜덤하게 2개 선택
  const shuffled = [...images].sort(() => Math.random() - 0.5);
  return [shuffled[0], shuffled[1]];
}

/**
 * 속성 변환 함수
 * 에디터에서 전달된 props를 컴포넌트에서 사용할 수 있는 형태로 변환
 */
export function adaptDualBannerProps(props: DualBannerProps): AdaptedDualBannerProps {
  const { id, style = {}, componentProps = {} } = props;
  
  // 기본 구조 생성
  const adaptedProps: AdaptedDualBannerProps = {
    id,
    style,
    data: {}
  };
  
  // 필요한 속성 추출 및 변환
  const images = componentProps.images || [];
  const selectedImages = selectRandomImages(images);
  
  adaptedProps.data = {
    images: images,
    selectedImages: selectedImages,
    overlayColor: componentProps.overlayColor || '#000000',
    overlayOpacity: componentProps.overlayOpacity !== undefined ? componentProps.overlayOpacity : 0.3,
    textColor: componentProps.textColor || '#ffffff',
    height: componentProps.height || 400,
    gap: componentProps.gap || 10,
    // device 객체가 있으면 그대로 사용
    device: componentProps.device
  };
  
  return adaptedProps;
}